export const local = 'fr'